import type { FaireProductEntity } from "../../entity_types/product";

export const p_amku54mbf2: FaireProductEntity = {
  token: "p_amku54mbf2",
  type: "product",
  name: "Tennis Legend Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/63556e030881a887367d2d9d08514803692a7520ebdb01172760ff25aeceb6b5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/65e0ed0b92bff6df9b8302664ef6ed563648967c5beed3c98fdf5ae1a509445f.jpeg",
    "https://cdn.faire.com/fastly/6f548b52ce18853c20aba5f74228430208bbee580b996f16f1539f2ab8576ff4.jpeg",
    "https://cdn.faire.com/fastly/391c5ce5ab59bd650a6891bed7080c0c4dc2d9b1ce982c89cc5843ec8e043e9b.jpeg",
    "https://cdn.faire.com/fastly/84494f621f13e0030da8ad2037e58803bcfebdf8a0b7fa6fa6de1797294e904a.jpeg",
    "https://cdn.faire.com/fastly/5a56d4cbc992c373455f850562f47839c673dcf9f524d434fc90477feabfc698.jpeg"
  ],
  priceDollars: 6.75,
  description: "These socks are perrrrfect for anyone with a killer backhand. 😮 💨🎾\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:14.266Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
